import React, { useState, useCallback } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SettingsIcon from "@mui/icons-material/Settings";
import ScreenContainer from "../../Components/ScreenContainer";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import AlertSettingsAlertList from "../../PagesContent/BmsFaults/AlertSettingsAlertList";
import AlertSettingsRightSidebar from "../../PagesContent/BmsFaults/AlertSettingsRightSidebar";

function AlertSettingsPage() {
  const navigate = useNavigate();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isSettingsOpen, setIsSettingsOpen] = useState(true);

  const handleBack = useCallback(() => navigate(-1), [navigate]);

  const handleFilterChange = useCallback((key, ids) => {
    setSelectedFilters((prev) => ({ ...prev, [key]: ids }));
  }, []);

  return (
    <ScreenContainer>
      {/*
        Top-level row: main content column + sidebar column.
        position:relative here anchors the toggle button so it spans the full page height,
        matching how ChartDetailsView structures its layout.
      */}
      <Box sx={{ display: "flex", height: "calc(100vh - 50px)", position: "relative" }}>

        {/* Main content column — shrinks when sidebar opens */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: isSettingsOpen ? "calc(100% - 320px)" : "100%",
            transition: "width 0.3s ease-in-out",
            overflow: "hidden",
            minWidth: 0,
          }}
        >
          {/* Header */}
          <Box sx={{ px: 3, pt: 2, pb: 2, bgcolor: "#FAFAFA", display: "flex", alignItems: "flex-start", gap: 1, flexShrink: 0 }}>
            <ChevronLeftIcon
              sx={{
                fontSize: 26,
                color: ThemeProperties.purple,
                cursor: "pointer",
                mt: "2px",
                borderRadius: "50%",
                transition: "color 0.2s, background-color 0.2s",
                "&:hover": {
                  color: ThemeProperties.dropDownPurple,
                  bgcolor: ThemeProperties.purpleLight,
                },
              }}
              onClick={handleBack}
              data-testid="alert-settings-back-btn"
            />

            <Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.75 }}>
                <Typography sx={{ fontSize: "18px", fontWeight: 400, color: "#3D4B5A", lineHeight: "24px" }}>
                  Smart Alerts
                </Typography>
                <Typography sx={{ color: "#686868", fontSize: "18px", lineHeight: "28px" }}>
                  /
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  <SettingsIcon sx={{ fontSize: 20, color: "#2E2E2E" }} />
                  <Typography sx={{ fontSize: "18px", fontWeight: 600, color: "#2E2E2E", lineHeight: "28px" }}>
                    Alert Settings
                  </Typography>
                </Box>
              </Box>
              <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#686868" }}>
                Configure and manage alerts for your EV battery fleet monitoring
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ borderColor: "#E4E3E3", flexShrink: 0 }} />

          {/* Content area — display:flex so white card uses flex:1 and stays within the 24px padding */}
          <Box sx={{ flex: 1, p: 3, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                flex: 1,
                bgcolor: "#FFFFFF",
                borderRadius: "12px",
                border: "1px solid #ECECF1",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ flex: 1, overflow: "auto", p: "24px 26px" }}>
                <AlertSettingsAlertList selectedFilters={selectedFilters} />
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Settings sidebar — sibling of main content, spans full page height */}
        <AlertSettingsRightSidebar
          isExpanded={isSettingsOpen}
          onToggle={() => setIsSettingsOpen((v) => !v)}
          selectedFilters={selectedFilters}
          onFilterChange={handleFilterChange}
        />

      </Box>
    </ScreenContainer>
  );
}

export default AlertSettingsPage;
